import common from '../language/th/common.json'
import login from '../language/th/login.json'
import report from '../language/th/report.json'
import fin from '../language/th/fin.json'
import fg from '../language/th/fg.json'
import tube from '../language/th/tube.json'
import search from '../language/th/search.json'
import header from '../language/th/search.json'
import plate from '../language/th/plate.json'
import button from '../language/th/button.json'
import home from '../language/th/home.json'
import menu from '../language/th/menu.json'
import sell from '../language/th/sell.json'
import systemInfo from '../language/th/systeminfo.json'
import master from '../language/th/masterData.json'
import setting from '../language/th/setting.json'
import share from '../language/th/share.json'
import user from '../language/th/user.json'
import reqDrawing from './th/reqDrawing.json'
import urlTranslate from './th/urlTranslate.json'


export default {
   ...common,
   ...login,
   ...report,
   ...fin,
   ...fg,
   ...tube,
   ...search,
   ...header,
   ...plate,
   ...button,
   ...home,
   ...menu,
   ...sell,
   ...systemInfo,
   ...master,
   ...setting,
   ...share,
   ...user,
   ...reqDrawing,
   ...urlTranslate
}


// WEBPACK FOOTER //
// ./src/wording/language/th.js